import { TEMPLATE_TYPES } from 'cpool-constants';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class Template_MailCreated extends _Event {
    constructor(payload: EventSchema<Template_MailCreated>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            active: z.boolean().nullish(),
            mailContent: z.string().min(1),
            mailHTMLContent: z.string().min(1),
            name: z.string().min(1),
            priority: z.optional(z.number().int().default(0)),
            subject: z.string().min(1),
            technicalDescription: z.optional(z.string().min(1).nullable()),
            type: z.literal(TEMPLATE_TYPES.MAIL),
        });
    }

    static example(): EventSchema<Template_MailCreated> {
        return {
            mailContent: 'This is the mail content',
            mailHTMLContent: '<html><body>This is the mail HTML content</body></html>',
            name: 'Mail Template',
            priority: 0,
            subject: 'Mail Template Subject',
            type: TEMPLATE_TYPES.MAIL,
        };
    }
}
